import React from 'react';
import PropTypes from 'prop-types';
import { fromUnixTime } from 'date-fns';
import classNames from 'classnames';
import Message from 'components/Message';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  lastUpdate: {
    id: 'last-update.last-update',
    defaultMessage:
      'Last update: {date, date, long-w-dow-time}{userSource, select, undefined {} admin { · AutoSync} dashboard { · Partner} dashboardWithEmail { · {userEmail}} other { · AutoSync}}',
  },
});

const LastUpdate = ({ timestampSeconds, userSource, userEmail, className }) => {
  if (!timestampSeconds) return null;
  if (userEmail) userSource = 'dashboardWithEmail';

  return (
    <Message
      as="div"
      className={classNames('text--sm text--light p-s', className)}
      message={messages.lastUpdate}
      values={{ userSource, date: fromUnixTime(timestampSeconds), userEmail }}
    />
  );
};

LastUpdate.propTypes = {
  className: PropTypes.string,
  timestampSeconds: PropTypes.number,
  userEmail: PropTypes.string,
  userSource: PropTypes.string,
};

export default LastUpdate;
